import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Planificación Anual',
    value: '$9.990',
    desc: 'Todo el año organizado'
  }, {
    title: 'Banco de Ejercicios',
    value: '$7.990',
    desc: 'Ejercicios listos por nivel'
  }, {
    title: 'Repertorio de Canciones',
    value: '$9.990',
    desc: 'Canciones clasificadas'
  }, {
    title: 'Sistema de Evaluación',
    value: '$7.990',
    desc: 'Seguimiento del alumno'
  }];
  return <section className="bg-[#0a1128] py-4 md:py-6 px-3 border-y border-[#1e293b]" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4" data-id="element-16">
          🎁 BONUS DE REGALO
        </h2>

        <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#050a1a] border border-[#1e293b] rounded-lg p-3 relative overflow-hidden" data-id="element-18">
              <div className="absolute top-0 right-0 bg-[#2563eb] text-white text-[9px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-19">
                #{i + 1}
              </div>
              <h3 className="text-sm font-bold text-white mb-0.5 flex items-center gap-1 mt-1" data-id="element-20">
                <span className="text-[#eab308]" data-id="element-21">🎁</span> {bonus.title}
              </h3>
              <p className="text-gray-400 text-xs mb-2" data-id="element-22">{bonus.desc}</p>
              <div className="border-t border-[#1e293b] pt-1.5 flex justify-between items-center" data-id="element-23">
                <span className="text-gray-500 line-through text-[10px]" data-id="element-24">
                  {bonus.value}
                </span>
                <span className="text-[#10b981] font-black text-xs" data-id="element-25">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-xs mx-auto bg-[#050a1a] border-2 border-[#eab308] rounded-xl p-3 text-center glow-yellow" data-id="element-26">
          <p className="text-gray-400 text-xs mb-0.5" data-id="element-27">
            Valor total de los bonus:
          </p>
          <p className="text-xl font-bold text-red-500 line-through mb-1" data-id="element-28">
            $35.960
          </p>
          <p className="text-3xl font-black text-[#10b981]" data-id="element-29">🔥 HOY: GRATIS</p>
        </div>
      </div>
    </section>;
}